// 我的设备
import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}


//客户管理 -- 查询公司和项目 -- 潘
// getData.MDdevicestatics = (data)=>{ 
//     return http.get(baseUrl+"/one/devicestatics/",{ params:data })
// }
// ---------------全部综合信息-----------
// 统计设备状态 -- 潘
getData.MDdevicestatics = (data)=>{ 
    return http.post(baseUrl+"/one/devicestatics/",data)
}
// 项目设备侧边栏、项目基础信息 -- 潘
getData.MDcompanyprojectdevices = (data)=>{ 
    return http.post(baseUrl+"/one/companyprojectdevices/",data)
}
// 查看组态图 -- 潘 
getData.MDmydevicedashboardlist = (data)=>{ 
    return http.post(baseUrl+"/one/mydevicedashboardlist/",data)
}
// 查看实时负荷 -- 潘 
getData.MDdevicepowerloadnew = (data)=>{ 
    return http.post(baseUrl+"/one/mydevicepowerloadnew/",data)
}
// 用电实时负荷 -- 潘 
getData.MDdeviceelecpowerloadnew = (data)=>{ 
    return http.post(baseUrl+"/one/mydeviceelecpowerloadnew/",data)
}
// 主蒸汽温度压力 -- 潘 
getData.MDdevicesteampresstempnew = (data)=>{ 
    return http.post(baseUrl+"/one/mydevicesteampresstempnew/",data)
}
// 主蒸汽流量 -- 潘 
getData.MDdevicesteamsupply = (data)=>{ 
    return http.post(baseUrl+"/one/mydevicesteamsupply/",data)
}
// 汽轮机转速 -- 潘 
getData.MDdeviceturbinespeednew = (data)=>{ 
    return http.post(baseUrl+"/one/mydeviceturbinespeednew/",data)
}
// 设备综合效率接口 -- 潘 
getData.MDdevicepowerrate = (data)=>{ 
    return http.post(baseUrl+"/one/mydevicepowerrate/",data)
}
// 告警人员列表接口 -- 范
getData.alertpersonlist = (data)=>{ 
    return http.post(baseUrl+"/one/alertpersonlist/",data)
}

// ---------------------设备实时数据-----

// 实时数据:输出数值量或者开关量相关参数的实时值 -- 潘 
getData.MDdevicetyperealtimedata = (data)=>{ 
    return http.post(baseUrl+"/one/mydevicetyperealtimedata/",data)
}
// 设备实时数据->实时对比分析 -- 潘 
getData.MDdevicerealtimedata = (data)=>{ 
    return http.post(baseUrl+"/one/mydevicerealtimedata/",data)
}



export default getData


// WEBPACK FOOTER //
// ./src/common/myDevice.js